import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sub-definition',
  templateUrl: './sub-definition.component.html',
  styleUrls: ['./sub-definition.component.sass']
})
export class SubDefinitionComponent implements OnInit {
  @Input() name: string;
  @Input() content: string;
  @Input() subtitle: string;
  
  constructor() { }

  ngOnInit() {
  }

}
